module.exports = __webpack_public_path__ + "media/images/icons/trash-5d2459cb98bbe268b9d8b7bf2b8ed536.svg";